import { Directive, ElementRef, HostListener, Optional } from '@angular/core';
import { FormGroupDirective } from '@angular/forms';
import { debounceTime, fromEvent, take } from 'rxjs';

@Directive({
  selector: '[locktonAppsInvalidControlScroller]',
  exportAs: 'laInvalidControlScroller',
  standalone: true,
})
export class InvalidControlScrollerDirective {
  constructor(
    private el: ElementRef,
    @Optional() private form: FormGroupDirective
  ) {}

  @HostListener('ngSubmit') onSubmit() {
    if (this.form.control.invalid) {
      this.scrollToFirstInvalidControl();
    }
  }
  manualSubmit() {
    this.scrollToFirstInvalidControl();
  }

  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement =
      this.el.nativeElement.querySelector('.ng-invalid');

    if (firstInvalidControl) {
      window.scroll({
        top: this.getTopOffset(firstInvalidControl),
        left: 0,
        behavior: 'smooth',
      });

      fromEvent(window, 'scroll')
        .pipe(debounceTime(100), take(1))
        .subscribe(() => firstInvalidControl.focus());
    }
  }

  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }
}
